module.exports = __webpack_public_path__ + "img/clock_success.b0235e2a.jpg";